
<template>
    <div class="Heading" :class="{ 'hasBottom': isBottomVisible, 'hasCompany': isCompanyUndefinedAllowed || company, 'hasTeleport': !!teleport_heading }">
        <div class="top">
            <div class="left">
                <Teleport :to="teleport_heading || 'body'" :disabled="!teleport_heading">
                <h1 class="h1">
                    <span class="main" v-if="!viewData.workflowcard_id">{{ trans(viewData.title) }}</span>
                    <span class="card" v-if="viewData.workflowcard_id && !viewData.config.settings?.target?.workflowcard_id">
                        <template v-if="viewData.title_prefix_detail">{{ viewData.title_prefix_detail }}&nbsp;</template>
                        <cardTitle v-if="viewData.item.data" :data="viewData.item.data" :key="viewData.workflowcard_id" />
                    </span>
                </h1>
                <h2 class="h2" v-if="viewData.subtitle">{{ trans(viewData.subtitle) }}</h2>
                </Teleport>
            </div>
            <div class="right">
                <nav id="navigationSpot"></nav>
            </div>
        </div>
        <div v-if="isBottomVisible && (isCompanyUndefinedAllowed || company)" class="bottom">
            <form v-if="viewData.searchable_property_names.length" class="element SearchField" @submit.prevent="handleSearch">
                <div class="input-group">
                    <div class="input-group-addon input-group-btn">
                        <button type="submit" class="btn useHand">
                            <Icon name="search" />
                        </button>
                    </div>
                    <input type="text" class="input form-control" :placeholder="trans('Zoeken')" v-model="search" @input="handleSearch" />
                </div>
            </form>
            <Filters />
            <WorkflowcardAdd v-if="isAddVisible && !viewData.config.settings?.target?.workflowcard_id && viewData.workflowboard_id" :workflowboard_id="viewData.workflowboard_id" />
        </div>
    </div>
</template>

<script>
import {defineComponent, inject, computed, ref, provide, reactive, watch} from "vue";

import Icon from "components/icon";
import trans from "helpers/_translation";

import cardTitle from "components/workflowcard/cardtitle";

import Filters from "components/workflowcard/filters";
import Actions from "components/workflowcard/actions";

import WorkflowcardAdd from "view/dashboard/includes/workflowcard-add";

import { workflowlayout, resolvePropertyType } from "store/workflow";
import { field, isCompanyUndefinedAllowed } from "store/portal";
import { company } from "store/company";
import { generalFilters } from "store/filters";

import cardtitle from "components/workflowcard/cardtitle";

export default defineComponent({
    name: "part",
    components: {
        Icon,
        Actions,
        Filters,
        cardTitle,
        WorkflowcardAdd,
        cardtitle
    },
    setup() {
        const appData = inject("appData");
        const viewData = inject("viewData");
        const isCommunity = inject("isCommunity");

        const handleTabClick = inject("handleTabClick");
        const tab_active = inject("tab_active");
        const tab_exists = inject("tab_exists");
        
        const overrule = inject("overrule");

        const goBack = () => {
            if (!viewData.workflowcard_id) return;
            router.back();
        };

        const isAddVisible = inject("isAddVisible");
        const isBottomVisible = inject("isBottomVisible");

        // Store overview data
        const handleOverviewData = inject("handleOverviewData");

        // Define timer
        let inputTimer;
        const search = ref("");
        const handleSearchValue = () => {
            handleOverviewData(search.value);
        };
        const handleSearch = (e) => {
            inputTimer && clearTimeout(inputTimer);
            inputTimer = setTimeout(handleSearchValue, e.type !== "submit" ? 500 : 0);
        };

        provide("search", search);

        const teleport_heading = computed(() => {
            if (!viewData.workflowcard_id) {
                return "#rightTopHeading";
            }
            return null;
        });

        return {
            trans,
            viewData,

            handleTabClick,
            tab_active,
            tab_exists,

            isCommunity,

            workflowlayout,
            field,
            company,

            resolvePropertyType,

            overrule,
            isAddVisible,
            isBottomVisible,
            isCompanyUndefinedAllowed,

            handleSearch,
            search,

            teleport_heading
        }
    }
});
</script>
